/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsubmit2Inputs */

const en_placewebsubmit2 = /** @type {(inputs: Placewebsubmit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the website`)
};

const de_placewebsubmit2 = /** @type {(inputs: Placewebsubmit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website lesen`)
};

/**
* | output |
* | --- |
* | "Read the website" |
*
* @param {Placewebsubmit2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsubmit2 = /** @type {((inputs?: Placewebsubmit2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsubmit2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsubmit2(inputs)
	return de_placewebsubmit2(inputs)
});
export { placewebsubmit2 as "placeWebSubmit" }